import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { UsePlaceAuth } from "../../AppContext/AppContext";
import contact from "../../demo/contact-us.svg";
import axios from "axios";
import ContactModal from "../Modals/ContactModal";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Audio_Tour, Car_Rentals, _Deals_, _Flight_, Hotel, Restaurants, Things_to_do, _Blog_ } from "../../Redux/Action/Action";
import RegLoginModal from "../Modals/RegLoginModal";
import { toast } from "react-toastify";
// import Blog from "../dashboard/blog/Blog";

function Header() {
	const place = useSelector(state => state.place);
	let { hotelUrl, setHotelUrl } = UsePlaceAuth();
	const [selectedCity, setSelectedCity] = useState("Choose City");
	const navigate = useNavigate();
	const location = useLocation();
	const [regLoginModal, setRegLoginModal] = useState(false);
	// console.log("hotelUrl",hotelUrl);

	let { flightUrl, setFlightUrl } = UsePlaceAuth();
	// console.log("flightUrl",flightUrl);
	const [contactModal, SetContactModal] = useState(false);
	const CallApi = async () => {
		axios
			.get(
				`${process.env.REACT_APP_BASE_URL}hotel-url?city=${place}`,
				{
					headers: {
						"Content-Type": "application/json",
					},
				}
			)
			.then(
				function (response) {
					setHotelUrl(response?.data?.data[0].city_id_code)
				},
				(error) => {
					console.log(error);
				}
			);
		axios
			.get(
				`${process.env.REACT_APP_BASE_URL}flight-url?city=${place}`,
				{
					headers: {
						"Content-Type": "application/json",
					},
				}
			)
			.then(
				function (response) {
					setFlightUrl(response?.data?.data[0].url)
				},
				(error) => {
					console.log(error);
				}
			);
	};
	useEffect(() => {
		CallApi();
	}, [place])

	const cityCodes = {
		'Chicago': 'CHI', 'Los Angeles': 'LAX', 'San Francisco': 'SFO', 'Miami': 'MIA', 'Las Vegas':
			'LAS', 'Boston': 'BOS', 'Seattle': 'SEA', 'Dallas': 'DFW', 'Atlanta': 'ATL', 'Orlando': 'MCO', 'Philadelphia': 'PHL', 'San Diego':
			'SAN', 'New York': 'NYC', 'Nashville': 'BNA', 'Houston': 'IAH', 'New Orleans': 'MSY', 'Denver': 'DEN', 'Phoenix': 'PHX',
		'Austin': 'AUS', 'Charlotte': 'CLT', 'Tampa': 'TPA', 'Portland': 'PDX', 'Salt Lake City': 'SLC',
		'San Antonio': 'SAT', 'Minneapolis': 'MSP', 'St Louis': 'STL', 'Charleston': 'CHS', 'Savannah': 'SAV', 'Honolulu': 'HNL'
	};

	const handleMenuIcon = () => {
		if (window.screen.width < 990) {
			document.getElementById("navbarSupportedContent").classList.remove("show")
		}
	}
	const active = useSelector(state => state.active);
	const dispatch = useDispatch();
	const [isToggled, setIsToggled] = useState(false);

	const toggleElements = () => {
		setIsToggled(!isToggled);
	};

	const handleLogout = () => {

		localStorage.removeItem('userName');
		localStorage.removeItem('token');
		localStorage.removeItem('userData');
		localStorage.removeItem('userEmail');
		localStorage.removeItem('selectedCity');
		setUserName(null);

	};
	const handleClick = () => {
		setRegLoginModal(true);
	};
	const [userName, setUserName] = useState(null);

	useEffect(() => {

		const storedUserName = localStorage.getItem('userName');
		if (storedUserName) {
			setUserName(storedUserName);
		}
	}, []);

	// Extract the city name from any of the matching routes
	const pathPrefixes = [
		'hotel',
		'flight',
		'car-rental',
		'restaurant',
		'things-to-do',
		'experiences',
		'audio-tour',
		'deal',
		'deals',
		'sports',
		'performing-arts',
		'brewery',
		'comedy',
		'family',
		'flights',
		'vacations',
		'hotels',
		'tours',
		'cruises',
		'adventures',
		'rock',
		'blues',
		'jazz',
		'country',
		'concerts',
		'performing-arts',
		'brewery',
		'comedy',
		'family',
		'car-rental',
	];

	// Extracts the city slug from the URL if it matches a known path prefix
	const extractPlace = (pathname) => {
		const pathSegments = pathname.split('/').filter(Boolean);

		// Loop through pathPrefixes and find where it exists
		for (let i = 0; i < pathSegments.length - 1; i++) {
			if (pathPrefixes.includes(pathSegments[i])) {
				// Return the segment after the prefix (assumed to be city)
				return pathSegments[i + 1];
			}
		}
		return null;
	};

	useEffect(() => {
		const citySlug = extractPlace(location.pathname);

		if (citySlug) {
			const decodedSlug = decodeURIComponent(citySlug).toLowerCase().replace(/\s+/g, '-');

			const matchedCity = Object.keys(cityCodes).find((cityName) => {
				const citySlugified = cityName.toLowerCase().replace(/\s+/g, '-');
				return citySlugified === decodedSlug;
			});

			if (matchedCity) {
				setSelectedCity(matchedCity);
				localStorage.setItem('selectedCity', matchedCity);
			}
		} else {
			const stored = localStorage.getItem('selectedCity');
			setSelectedCity(stored && stored !== 'undefined' ? stored : 'Choose City');
		}
	}, [location.pathname]);



	const localSelectedCity = localStorage.getItem('selectedCity');


	return (
		<React.Fragment>
			<header className="top-header">
				<nav className="navbar navbar-expand-lg">
					<div className="container">
						<Link className="navbar-brand"
							to={"/"}
							onClick={() => localStorage.removeItem('selectedCity')}
						>
							<img src="/images/logo.png" alt="logo" />
						</Link>
						<button
							className={`navbar-toggler ${isToggled ? 'show' : ''}`}
							type="button"
							onClick={toggleElements}
							aria-controls="navbarSupportedContent"
							// aria-expanded={isToggled} 
							aria-label="Toggle navigation">
							<span className="navbar-toggler-icon"></span>
						</button>
						<div className={`collapse navbar-collapse ${isToggled ? 'show' : ''}`} id="navbarSupportedContent">
							<ul className="navbar-nav ms-auto mb-2 mb-lg-0">

								<li className={active === "1" ? "nav-item  activeMenu" : "nav-item "} onClick={() => { dispatch(Hotel()); toggleElements(); }}>
									<Link className="nav-link headerIconss" to={
										localSelectedCity && localSelectedCity !== "undefined"
											? hotelUrl
											: '/hotel'
									}>
										<img src={
											active === "1"
												? "/images/hotelActive-icon.png"
												: "/images/hotel-icon.png"
										} alt="hotel-icon" />
										Hotel
									</Link>

								</li>
								<li className={active === "2" ? "nav-item  activeMenu" : "nav-item "} onClick={() => { dispatch(_Flight_()); handleMenuIcon() }}>
									<Link className="nav-link headerIconss" to={
										localSelectedCity && localSelectedCity !== "undefined"
											? flightUrl : '/flight'}>
										{/* <a className="nav-link" to={`/flight/${place}`}> */}
										<img src={
											active === "2"
												? "/images/flightActive-icon.png"
												: "/images/flight-icon.png"
										} alt="flight-icon" />
										Flight
									</Link>
								</li>
								<li className={active === "3" && location.pathname.startsWith("/car-rental") ? "nav-item activeMenu" : "nav-item"} onClick={() => { dispatch(Car_Rentals()); handleMenuIcon() }}>
									<Link className="nav-link headerIconss" to={place && localSelectedCity && localSelectedCity !== "undefined" ? `/car-rental/${place}` : '/car-rental'}>
										<img src={
											active === "3" && location.pathname.startsWith("/car-rental")
												? "/images/carRentalActive-icon.png"
												: "/images/carRental-icon.png"
										} alt="carRental-icon" />
										Car Rentals
									</Link>
								</li>
								<li className={active === "4" ? "nav-item activeMenu" : "nav-item"} onClick={() => { dispatch(Restaurants()); handleMenuIcon() }}>
									<Link to={place && localSelectedCity && localSelectedCity !== "undefined"
										? `/restaurant/${place}`
										: '/restaurant'} className="nav-link headerIconss" >
										<img src={
											active === "4"
												? "/images/restaurentActive-icon.png"
												: "/images/restaurent-icon.png"
										} alt="restaurent-icon" />
										Restaurants
									</Link>
								</li>
								<li className={active === "5" ? "nav-item activeMenu" : "nav-item"} onClick={() => { dispatch(Things_to_do()); handleMenuIcon() }}>
									<Link to={place && localSelectedCity && localSelectedCity !== "undefined"
										? `/things-to-do/${place}`
										: '/things-to-do/'} className="nav-link headerIconss">
										<img src={
											active === "5"
												? "/images/tingstodoActive-icon.png"
												: "/images/tingstodo-icon.png"
										} alt="tingstodo-icon" />
										Things to do
									</Link>
								</li>
								<li className="nav-item dropdown">
									<a className="nav-link headerIconss dropdown-toggle moreArrow" role="button" aria-label="Toggle navigation" data-bs-toggle="dropdown" aria-controls="navbarNav" aria-expanded="false">
										<img src="/images/more-icon.png" alt="more-icon" />
										More
									</a>
									<ul className="dropdown-menu ">
										<li className={active === "6" ? "activeMenu" : ""} onClick={() => {
											if (!localSelectedCity || localSelectedCity === "undefined") {
												toast.warning("Please select a city first");
											} dispatch(Audio_Tour()); handleMenuIcon()
										}}>
											<Link to={place && localSelectedCity && localSelectedCity !== "undefined"
												? `/audio-tour/${place}`
												: '/audio-tour'} className="dropdown-item headerIcons" >

												<img src={
													active === "6"
														? "/images/audiotureActive-icon.png"
														: "/images/audioture-icon.png"
												} alt="audioture-icon" />
												Audio Tour</Link>
										</li>
										<li className={active === "7" ? "activeMenu" : ""} onClick={() => { dispatch(_Deals_()); handleMenuIcon() }}>
											<Link className="dropdown-item headerIcons" to={place && localSelectedCity && localSelectedCity !== "undefined" ? `/deals/${place}` : `/deal`}>

												<img src={
													active === "7"
														? "/images/allinclusicActive-icon.png"
														: "/images/allinclusic-icon.png"
												} alt="allinclusic-icon" />
												Deals</Link>
										</li>
										<li className={active === "8" ? "activeMenu" : ""} onClick={() => { dispatch(_Blog_()); handleMenuIcon(); localStorage.removeItem("selectedCity"); }}><Link className="dropdown-item headerIcons" to={`/blog`}>
											<img src={
												active === "8"
													? "/images/blogActive-icon.png"
													: "/images/blog-icon.png"
											} alt="blog-icon" />
											Blog</Link>
										</li>
									</ul>
								</li>
								{/* <li className="nav-item"onClick={()=> {handleMenuIcon()}}><Link to="/trip" className="nav-link contact-button"><img loading="lazy" src={location}/> Trip</Link></li> */}
								{/* <li className="nav-item" onClick={() => { handleMenuIcon() }}><a href="#/" className="nav-link contact-button clickable" onClick={(e) => {e.preventDefault(); SetContactModal(true)}}><img loading="lazy" src={contact} alt="" />Contact Us</a></li> */}
								<li className="nav-item">
									{userName ? (
										<div className="dropdown">
											<Link
												className="nav-link user-name dropdown-toggle dropdown-item"
												id="userDropdown"
												data-bs-toggle="dropdown"
												aria-expanded="false"
											>
												<img loading="lazy" src={contact} alt="userName" /> {userName}
											</Link>
											<ul className="dropdown-menu" aria-labelledby="userDropdown">
												<li>
													<button className="dropdown-item" onClick={handleLogout}>
														Logout
													</button>
												</li>
											</ul>
										</div>
									) : (
										<a
											onClick={handleClick}
											className="nav-link contact-button clickable"
										>
											<img loading="lazy" src={contact} alt="" /> Login
										</a>
									)}
								</li>
								<li className="nav-item dropdown">
									<Link
										className="nav-link dropdown-toggle"
										to=""
										role="button"
										aria-label="Toggle navigation"
										data-bs-toggle="dropdown"
										aria-controls="navbarNav"
										aria-expanded="false"
									>
										{selectedCity}
									</Link>
									<ul className="dropdown-menu" style={{ maxHeight: '200px', overflowY: 'auto' }}>
										{Object.entries(cityCodes).map(([city, code]) => (
											<li key={code}>
												<Link className="dropdown-item" onClick={() => {
													setSelectedCity(city);
													navigate(`/experiences/${city.toLowerCase()}`);
													localStorage.setItem('selectedCity', city);
													window.location.reload();
												}}>
													{city}
												</Link>
											</li>
										))}
									</ul>
								</li>
							</ul>
						</div>
					</div>
				</nav>
			</header>
			{contactModal && <ContactModal contactModal={contactModal} SetContactModal={SetContactModal} />}
			{regLoginModal && (
				<RegLoginModal
					regLoginModal={regLoginModal}
					setRegLoginModal={setRegLoginModal}
				/>
			)}

		</React.Fragment>
	);
}
export default Header;
